export default {
    config: {
        fixedWidth: 48
    },
    default: {
        label: 'Group'
    },
    unique: [],
    sort: 'rating.group',
    lang: {
        name: 'Group Rating',
        category: 'User',
        description: 'Group average rating of the game.',
        views: ['list', 'sheet', 'grid'],
    },
    types: ['group'],
    filters: []
}